import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "game-guides",
  "aria-labelledby": "game-guides-title"
}
const _hoisted_2 = { id: "game-guides-title" }
const _hoisted_3 = ["aria-label"]

import LocaleLink from '@/components/feedback/LocaleLink.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'GameGuideLinks',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('wiki.gameGuides')), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('wiki.compareGames')), 1),
    _createElementVNode("nav", {
      "aria-label": _ctx.$t('wiki.gameGuides')
    }, [
      _createVNode(LocaleLink, { to: { name: 'social_deduction_games_online' } }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('wiki.guideSocialDeduction')), 1),
          _cache[0] || (_cache[0] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
        ]),
        _: 1
      }),
      _createVNode(LocaleLink, { to: { name: 'games_like_secret_hitler' } }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('wiki.guideSecretHitler')), 1),
          _cache[1] || (_cache[1] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
        ]),
        _: 1
      }),
      _createVNode(LocaleLink, { to: { name: 'avalon_vs_werewolf' } }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('wiki.guideWerewolf')), 1),
          _cache[2] || (_cache[2] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
        ]),
        _: 1
      })
    ], 8, _hoisted_3)
  ]))
}
}

})